<template>
	<div>
		<b-form-row class="mb-3">
			<b-col cols="4">
				<b-input v-model="q" placeholder="Search..."/>
			</b-col>
			<b-col cols="1">
				<b-input v-model="lang" placeholder="Language"/>
			</b-col>
			<b-col cols="3" class="d-flex justify-content-around align-items-center">
				<b-form-checkbox v-model="isBanned" class="d-inline-flex">Banned</b-form-checkbox>
				<b-form-checkbox v-model="isDefault" class="d-inline-flex">Default</b-form-checkbox>
			</b-col>
			<b-col cols="4">
				<b-input v-model="text" placeholder="Sample text"/>
			</b-col>
		</b-form-row>
		<b-table :items="voices" :fields="['play', 'voice', 'provider', 'selector', 'settings', { key: 'actions', thClass: 'text-right', tdClass: 'text-right'}]" small striped :busy="loading > 0">
			<template #cell(play)="data">
				<b-button size="sm" @click="playVoice(data.item)" variant="primary" v-b-tooltip.hover.left.v-secondary title="Play"><b-icon :icon="data.item.playing ? 'stop' : 'play'"></b-icon></b-button>
			</template>
			<template #cell(voice)="data">
				{{data.item.name}}{{data.item.user_voice_alias?` (${data.item.user_voice_alias})`:''}}<br />
				<small>{{data.item.language}} {{data.item.sex}}</small>
			</template>
			<template #cell(provider)="data">
				{{data.item.provider||'-'}}<br />
				<small>{{data.item.type}}</small>
			</template>
			<template #cell(selector)="data">
				<code v-if="data.item.selector">!voice {{data.item.selector}}</code><br />
				<code v-if="data.item.unique_id">!voice {{data.item.unique_id}}</code>
			</template>
			<template #cell(settings)="data">
				<b-form-checkbox switch v-model="data.item.is_banned" :value="1" :unchecked-value="0" @change="toggleUserVoiceBanned(data.item)" :disabled="data.item.changingStatus" :state="data.item.changingState">Ban</b-form-checkbox>
				<b-form-checkbox switch v-model="data.item.is_default" :value="1" :unchecked-value="0" @change="setUserVoiceDefault(data.item)" :disabled="data.item.changingDefault" :state="data.item.changingDefaultState">Default</b-form-checkbox>
			</template>
			<template #cell(actions)="data">
				<b-button-group size="sm">
					<b-button @click="editVoice(data.item)" variant="secondary" v-b-tooltip.hover.right.v-secondary title="Edit voice"><b-icon icon="pencil"></b-icon></b-button>
				</b-button-group>
			</template>
		</b-table>
		<pager :per-page="perPage" :skip="skip" :total="total" @change="setPage"></pager>
		<b-alert variant="danger" :show="!!error" class="mt-3 mb-0">{{error}}</b-alert>
		<b-modal ref="voiceEditModal" title="Edit voice settings" :busy="loading > 0">
			<b-form @submit.stop.prevent="saveVoice(); return false" id="voiceEditForm">
				<b-form-group label="Alias">
					<b-form-input v-model="curVoice.user_voice_alias" />
				</b-form-group>
				<b-form-group label="Ban status">
					<b-form-checkbox switch v-model="curVoice.is_banned" :value="1" :unchecked-value="0">Banned</b-form-checkbox>
				</b-form-group>
				<b-form-group label="Is default">
					<b-form-checkbox switch v-model="curVoice.is_default" :value="1" :unchecked-value="0">Default</b-form-checkbox>
				</b-form-group>
			</b-form>
			<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
			<template #modal-footer="{cancel}">
				<b-spinner v-show="loading>0" small label="Loading"></b-spinner>
				<b-button size="sm" variant="success" type="submit" form="voiceEditForm">
					Save
				</b-button>
				<b-button size="sm" @click="cancel()">
					Cancel
				</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
import debounce from 'debounce';
import Pager from '@/components/Pager.vue';

export default {
	data() { return {
		loading: 0,
		error: null,
		voices: [],
		curVoice: {},
		perPage: 10,
		skip: 0,
		total: 0,
		q: '',
		lang: 'en',
		isBanned: 0,
		isDefault: 0,
		voicesPageUrl: 'https://asdf',
		voicesPageStatus: 'disabled',
		text: 'Type your text here',
		rate: .5,
		pitch: .5,
	}},
	components: {
		Pager
	},
	async mounted() {
		try {
			this.loading++;
			this.error = null;

			this.q = this.$route.query.q||'';
			this.lang = this.$route.query.lang||'';
			this.isBanned = !!this.$route.query.banned;
			this.isDefault = !!this.$route.query.default;
			this.skip = parseInt(this.$route.query.skip||0)||0;
			this.perPage = parseInt(this.$route.query.perPage||10)||10;

			this.voices = [];
			await this.loadVoices();

			this.$watch('$route', $route => {
				this.skip = parseInt($route.query.skip||0)||0;
				this.perPage = parseInt($route.query.perPage||10)||10;
				this.reloadVoices();
			});
			this.$watch('q', debounce(q => this.$router.push({
				path: this.$route.path,
				query: {
					...this.$route.query,
					skip: undefined,
					q: q||undefined,
				},
			}), 300));
			this.$watch('lang', debounce(lang => this.$router.push({
				path: this.$route.path,
				query: {
					...this.$route.query,
					skip: undefined,
					lang: lang||undefined,
				},
			}), 300));
			this.$watch('isBanned', isBanned => this.$router.push({
				path: this.$route.path,
				query: {
					...this.$route.query,
					skip: undefined,
					banned: isBanned ? '1' : undefined,
				},
			}));
			this.$watch('isDefault', isDefault => this.$router.push({
				path: this.$route.path,
				query: {
					...this.$route.query,
					skip: undefined,
					default: isDefault ? '1' : undefined,
				},
			}));
		} catch(e) {
			console.error(e);
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	methods: {
		async loadVoices() {
			const result = await this.$api.get('userVoices', {
				q: this.$route.query.q||'',
				lang: this.$route.query.lang||'',
				banned: this.$route.query.banned ? '1' : '',
				default: this.$route.query.default ? '1' : '',
				skip: this.skip,
				limit: this.perPage,
			});
			this.voices = result.results;
			this.total = result.total;
		},
		async reloadVoices() {
			try {
				this.loading++;
				this.error = null;
				await this.loadVoices();
			} catch(e) {
				console.error(e);
				this.error = e;
			} finally {
				this.loading--;
			}
		},
		copyVoicesPageUrlToClipboard() {
			this.$refs.voicesPageUrl.focus();
			document.execCommand('copy');
			this.$bvToast.toast('Copied to clipboard', { title: 'Success', variant: 'success', solid: true });
		},
		editVoice(item) {
			this.loading++;
			this.error = null;
			this.$api.get(`userVoice/${encodeURIComponent(item.provider)}/${encodeURIComponent(item.id)}`).then(voice => {
				this.curVoice = voice;
			}, err => this.error = err).finally(() => {
				this.loading--;
			});

			this.$refs.voiceEditModal.show();
		},
		saveVoice() {
			this.loading++;
			this.error = null;
			this.$api.post(`userVoice/${encodeURIComponent(this.curVoice.provider)}/${encodeURIComponent(this.curVoice.id)}`, {
				alias: this.curVoice.user_voice_alias,
				is_banned: this.curVoice.is_banned,
				is_default: this.curVoice.is_default,
			}).then(() => {
				this.$refs.voiceEditModal.hide();
				this.$bvToast.toast('Voice settings saved', { title: 'Success', variant: 'success', solid: true });
				this.loadVoices();
			}, err => {
				this.error = err;
			}).finally(() => {
				this.loading--;
			});
		},
		toggleUserVoiceBanned(item) {
			this.$set(item, 'changingStatus', true);
			this.$set(item, 'changingState', undefined);
			this.loading++;
			this.error = null;
			this.$api.post(`userVoice/${encodeURIComponent(item.provider)}/${encodeURIComponent(item.id)}`, {
				is_banned: item.is_banned
			}).then(() => {
				this.$set(item, 'changingState', undefined);
				this.$bvToast.toast('Voice status changed', { title: 'Success', variant: 'success', solid: true });
			}, err => {
				this.$set(item, 'changingState', false);
				this.$bvToast.toast(err.message||err, { title: 'Could not change voice status', variant: 'danger', solid: true });
			}).finally(() => {
				this.$set(item, 'changingStatus', false);
				this.loading--;
			});
		},
		setUserVoiceDefault(item) {
			this.$set(item, 'changingDefault', true);
			this.$set(item, 'changingDefaultState', undefined);
			this.loading++;
			this.error = null;
			this.$api.post(`userVoice/${encodeURIComponent(item.provider)}/${encodeURIComponent(item.id)}`, {
				is_default: item.is_default
			}).then(() => {
				this.$set(item, 'changingDefaultState', undefined);
				this.$bvToast.toast('Voice status changed', { title: 'Success', variant: 'success', solid: true });
			}, err => {
				this.$set(item, 'changingDefaultState', false);
				this.$bvToast.toast(err.message||err, { title: 'Could not change voice status', variant: 'danger', solid: true });
			}).finally(() => {
				this.$set(item, 'changingDefault', false);
				this.loading--;
			});
		},
		playVoice(item) {
			if(this.audio) {
				this.audio.pause();
				if(item.playing) {
					this.$set(item, 'playing', false);
					return;
				}
			}
			this.$voiceApi.synthesizeRequest(this.text || 'Type your text here', item.provider, item.id, 0, 0).then(r => r.blob()).then(blob => {
				this.audio = new Audio(window.URL.createObjectURL(blob));
				this.audio.addEventListener('ended', () => {
					this.$set(item, 'playing', false);
					this.audio = null;
				})
				this.audio.addEventListener('pause', () => {
					this.$set(item, 'playing', false);
					this.audio = null;
				})
				this.audio.addEventListener('canplaythrough', () => {
					if(!this.audio) return;
					this.audio.play();
					this.$set(item, 'playing', true);
				});
			});
		},
		setPage($event) {
			this.$router.push({
				path: this.$route.path,
				query: {
					...this.$route.query,
					skip: $event.skip || undefined,
					perPage: $event.perPage == 10 ? undefined : $event.perPage,
				},
			});
		},
	}
};
</script>
